import dayjs from 'dayjs';
import Cookies from 'universal-cookie';

class CookieService {
  static getAccessToken = () => {
    const cookie = new Cookies();
    return cookie.get('accessToken');
  };

  static getRefreshToken = () => {
    const cookie = new Cookies();
    return cookie.get('refreshToken');
  };

  static getRubikaToken = () => {
    const cookie = new Cookies();
    return cookie.get('rubikaToken');
  };

  static getRubikaUser = () => {
    const cookie = new Cookies();
    return cookie.get('rubikaUser');
  };

  static getShadToken = () => {
    const cookie = new Cookies();
    return cookie.get('shadToken');
  };

  static setAccessToken = (token: string) => {
    const cookie = new Cookies();
    return cookie.set('accessToken', token, {
      path: '/',
      expires: dayjs().add(30, 'day').toDate(),
    });
  };

  static setRefreshToken = (token: string) => {
    const cookie = new Cookies();
    return cookie.set('refreshToken', token, {
      path: '/',
      expires: dayjs().add(30, 'day').toDate(),
    });
  };

  static setRubikaToken = (token: string) => {
    const cookie = new Cookies();
    return cookie.set('rubikaToken', token, {
      path: '/',
    });
  };

  static setRubikaUser = (user: string) => {
    const cookie = new Cookies();
    return cookie.set('rubikaUser', user, {
      path: '/',
    });
  };

  static setShadToken = (token: string) => {
    const cookie = new Cookies();
    return cookie.set('shadToken', token, {
      path: '/',
    });
  };
}

export default CookieService;
